import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CentroCostosService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/corelm/CentroCostosLM';
  }

  getCentroCostosLM(){
    return this.httpClient.get(this.endpoint + '/GetCentroCostosLM');
  }

  invalidateCache(){
    return this.httpClient.post(this.endpoint + '/InvalidateCache', {});
  }

}
